export enum ComplianceStatus {
  APPROVED = 'APPROVED',
  POTENTIAL_MATCH = 'POTENTIAL_MATCH',
  MATCH = 'MATCH',
}
